import React from 'react';
import ExternalCalendarEventViewControl from '../../CalendarIntegration/components/ExternalCalendarEventControl';

const ExternalEventActions = ({ task }) => {
    return (
        <div className="event-act-buttons">
            <ExternalCalendarEventViewControl event={task} />
        </div>
    );
};

export default ExternalEventActions;
